import React, { useEffect, useState } from 'react';
import { Box, Text, TextInput } from 'grommet';
import { FieldWeight } from '@helpers/FormFields';
import { ClaimedPlayer } from '../claimedPlayer';

const PlayerBiometrics: React.FC<{
  values: ClaimedPlayer | undefined;
  updateValues: (value: Record<string, unknown>) => void;
}> = ({ values, updateValues }) => {
  const [playerHeight, setPlayerHeight] = useState<string>(
    values?.height || '5\'5"'
  );
  useEffect(() => {
    updateValues({ height: playerHeight });
  }, [playerHeight, updateValues]);
  return (
    <>
      <Box gap="xsmall" margin={{ vertical: 'xsmall' }}>
        <Text size="large" color="dark-3">
          Height
        </Text>
        <Box direction="row" gap="xsmall" align="center">
          <TextInput
            autoComplete="nope"
            id="height-feet-id"
            placeholder="5"
            maxLength={2}
            onChange={(e) => {
              const ft = e.target.value;
              setPlayerHeight((prev: string) => `${ft}'${prev.split("'")[1]}"`);
            }}
            value={values?.height ? values.height.split("'")[0] : ''}
            plain
          />
          <Text color="text-weak">ft</Text>
          <TextInput
            autoComplete="nope"
            id="height-inches-id"
            placeholder="5"
            maxLength={2}
            onChange={(e) => {
              const inch = e.target.value;
              setPlayerHeight(
                (prev: string) => `${prev.split("'")[0]}'${inch}"`
              );
            }}
            value={
              values?.height ? values.height.split("'")[1].replace('"', '') : ''
            }
            plain
          />
          <Text color="text-weak">in</Text>
        </Box>
      </Box>
      <FieldWeight />
    </>
  );
};
export default PlayerBiometrics;
